import { render, staticRenderFns } from "./withdrawDetails.vue?vue&type=template&id=28a32598&scoped=true&"
import script from "./withdrawDetails.vue?vue&type=script&lang=js&"
export * from "./withdrawDetails.vue?vue&type=script&lang=js&"
import style0 from "./withdrawDetails.vue?vue&type=style&index=0&id=28a32598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a32598",
  null
  
)

component.options.__file = "withdrawDetails.vue"
export default component.exports